"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = true;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false;
// Fixed variables
var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "BuilderID";
var cartExtraInfo;
//extra classes for the elements
var removeExtraClass = "btn-border-black-animate";
// recharge 2020
var frequency = "";
var recurringchecked = false;
var frequency_unit = "";
//SVG icons
var removeMiniCartTextOrIcon = '<svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg">   <path fill="#253032" d="M.5.563h10v2H.5z"/> </svg>';
var minusIcon = '<svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg">   <path fill="#253032" d="M.5.563h10v2H.5z"/> </svg>';
var plusIcon = '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.563v4h2v-4h4v-2h-4v-4h-2v4h-4v2h4z" fill="#253032"/> </svg>';
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  //	window.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=XXX.myshopify.com";
  //window.location = '/checkout';
});
/*
EVENTS
1. Update quantity
2. remove item from cart
3. reload ajax cart
4. quickCartTotal
5. cart.requestComplete
*/
//QUANTITY UPDATE
function updateCartQuantity(cartThis) {
  var id = $(cartThis).attr("data-variant-id");
  var quantity = $("#updates_" + id).val();
  var type = $(cartThis).attr("date-type");
  //console.log("quantity" + quantity);
  //console.log("type" + type);
  //console.log("id" + id);
  var newQuantity = 0;
  if (quantity != "") {
    newQuantity = parseInt(quantity);
    if (type == "type") {} else {
      if (type == "plus") {
        newQuantity = newQuantity + 1;
      } else {
        if (newQuantity > 0) {
          newQuantity = newQuantity - 1;
        }
      }
    }

    //console.log("newQuantity" + newQuantity);

    var formData = {
      updates: {}
    };
    formData.updates[id] = newQuantity;
    // Perform the AJAX request to update the cart
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: formData,
      dataType: "json",
      success: function (cart) {
        // Perform any additional tasks after removing items
        $("#updates_" + id).val(newQuantity);
        getCartData(cart);
      },
      error: function (error) {
        // Handle error if the request fails
        console.error("Error updating items from the cart:", error);
      }
    });
  }
}

/* If you need extra information like collection title, metafield etc then use this function */
function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //   cartInfo(data);
  $.ajax({
    type: "GET",
    url: "/cart?view=alternate.json",
    success: function (response) {
      //console.log("success")
      //extra information against the cart like collection title metafield, product title metafield, tags
      cartExtraInfo = $.parseJSON(response);
      cartInfo(data);
    },
    error: function (status) {
      console.warn("ERROR", status);
      cartInfo(data);
    }
  });
}
$(document).on("click", ".js__recharge-switch", function () {
  var id = $(this).attr("data-id");
  var lineQuantity = $(this).attr("data-qty");
  var lineCount = id;
  if ($(this).is(':checked')) {
    $("#rechagrePlanID" + id).addClass("active");
    $("#rechagrePlanID" + id).parent("div").children(".update-text").show();
    $("#rechagrePlanID" + id).children("li:first-child").click();
  } else {
    $("#rechagrePlanID" + id).removeClass("active");
    $("#rechagrePlanID" + id).parent("div").children(".update-text").hide();
    CartJS.updateItem(lineCount, lineQuantity, {
      selling_plan: ""
    }, {
      success: function (data, textStatus, jqXHR) {},
      error: function (jqXHR, textStatus, errorThrown) {}
    });
  }
});
$(document).on("click", ".js__rechagre-options li", function () {
  var planID = $(this).attr("data-id");
  var lineCount = $(this).parent("ul").attr("id").replace('rechagrePlanID', "");
  var lineQuantity = $(this).parent("ul").attr("data-qty");
  $(this).parent("ul").children("li").removeClass("active");
  $(this).addClass("active");
  CartJS.updateItem(lineCount, lineQuantity, {
    selling_plan: parseInt(planID)
  }, {
    success: function (data, textStatus, jqXHR) {},
    error: function (jqXHR, textStatus, errorThrown) {}
  });
});

//RELOAD AJAX CART
function cartInfo(data) {
  var lineCount = 1;
  var cartObject;
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }
  $(".js__ajax-products-bind").html("");
  $(".js__ajax-products-bind").removeClass("empty");
  $(".cart-list").html("");
  if (cartObject.items.length == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__cart-four-column-product").hide();
    $(".js__ajax-products-bind").html("<li>No items in cart</li>");
    $(".js__ajax-products-bind").addClass("empty");
    $(".js__ajax-cart-count.cart-count").hide();
  } else {
    $(".js__ajax-cart-count.cart-count").css("display", "flex");
    $(".js__top-cart-form-actions").show();
    $(".js__cart-four-column-product").show();
    $(cartObject.items).each(function () {
      var imageURL = this.featured_image.url;
      //imageURL = imageURL[0] + "." + imageURL[1] + '_450x450' + "." + imageURL[2];
      var imageAlt = this.featured_image.alt;
      var itemPrice = this.original_price;
      var itemLinePriceTotal = this.line_price;
      var handle = this.handle;
      var itemID = this.id;
      var itemPriceAfterDiscount = this.discounted_price;
      var comparePrice = "";
      let disabled = "";
      let finalLineItemPrice = this.final_line_price;
      let cartBundleBoxID = "";
      let boolPromoOffer = false;
      let productTitle = this.product_title;
      let url = this.url;
      let itemProperties = "";
      let itemPropertiesElement = "";
      let itemPropertiesElementMiniCart = "";
      var boolItemBoxType = false;
      var hideElementClass = "";
      var readonly = "";
      var justifyCenter = "";
      let sellingPlayInformation = "";
      if (this.selling_plan_allocation != undefined) {
        sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
      }
      var ProductType = "";
      if (this.properties != null) {
        itemProperties = this.properties;
        if (Object.keys(itemProperties).length > 0) {
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID) {
              cartBundleBoxID = value;
            }
            if (key == "_ProductUrl") {
              url = value;
            }
            if (key == "_promoOffer") {
              boolPromoOffer = true;
            }
          });
          /* Checking the Box ID for the builder */
          itemPropertiesElementMiniCart = "";
          itemPropertiesElement = "<ul>";
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID || key == "_FreeGift") {
              hideElementClass = "hide";
              readonly = "readonly='readonly'";
              boolItemBoxType = true;
              justifyCenter = "justify-center ";
              url = "javascript:;";
              ProductType = "FreeGift";
            }
            if (key.indexOf("_") > -1) {} else {
              if (key != boxID) {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              } else {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              }
            }
            // Recharge - when subscription is via properties for older recharge version before November 2020
            recharge2020(key, value);
          });
          itemPropertiesElementMiniCart = itemPropertiesElement + "</ul>";
          // Recharge 2020, check if it's a subscription, then bind the value in the UL
          if (recurringchecked) {
            itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
            itemPropertiesElement += "</li>";
          }
          itemPropertiesElement += "</ul>";
        } else {
          //itemPropertiesElement = "";
        }
      }
      var rechargeSelected = this.selling_plan_allocation;
      var sellingPlanID = "";
      if (this.selling_plan_allocation != undefined) {
        sellingPlanID = this.selling_plan_allocation.selling_plan.id;
      }
      var rechargeDropdown = "";
      var rechargeRadio = "";
      /* Loop through cartExtraInformation section */
      $(cartExtraInfo.items).each(function (key, value) {
        if (value.id == itemID) {
          if (value.comparePrice != null) {
            comparePrice = value.comparePrice;
          }
          if (value.productImage != null) {
            imageURL = value.productImage;
          }
          var Quantity = value.quantity;
          if (ProductType == "FreeGift") {
            if (parseInt(Quantity) > 1) {
              /*Update Free Gift Quantity if more than 1*/
              var formData = {
                updates: {}
              };
              formData.updates[itemID] = 1;
              // Perform the AJAX request to update the cart
              $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: formData,
                dataType: "json",
                success: function (cart) {
                  // Perform any additional tasks after removing items
                  Quantity = 1;
                  getCartData(cart);
                },
                error: function (error) {
                  // Handle error if the request fails
                  console.error("Error updating items from the cart:", error);
                }
              });
            }
          }
          if (value.product_recharge == "True") {
            //console.log("value.product_rechargePrice" + value.product_rechargePrice)

            var optionActive = "active";
            if (rechargeSelected == undefined) {
              optionActive = "";
            }
            var rechargeOptions = "<ul id='rechagrePlanID" + lineCount + "' data-qty=" + Quantity + " class='rechagre-options js__rechagre-options " + optionActive + "'>";
            var productRechargeDiscount = "";
            var rechargeSelectOptions = "";
            $(value.recharge).each(function (key, valueRecharge) {
              if (sellingPlanID == valueRecharge.product_rechargeID) {
                rechargeOptions += "<li class='active' data-id=" + valueRecharge.product_rechargeID + ">" + valueRecharge.product_rechargeName.replace('Delivery every ', '') + "</li>";
                productRechargeDiscount = valueRecharge.product_rechargeDiscount;
                rechargeSelectOptions += "<option selected value=" + valueRecharge.product_rechargeID + ">" + valueRecharge.product_rechargeName + "</option>";
              } else {
                rechargeOptions += "<li data-id=" + valueRecharge.product_rechargeID + ">" + valueRecharge.product_rechargeName.replace('Delivery every ', '') + "</li>";
                productRechargeDiscount = valueRecharge.product_rechargeDiscount;
                rechargeSelectOptions += "<option value=" + valueRecharge.product_rechargeID + ">" + valueRecharge.product_rechargeName + "</option>";
              }
            });
            rechargeOptions += "</ul>";
            if (rechargeSelected == undefined) {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + Quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'>" + rechargeSelectOptions + "<option value='One Time Purchase' selected>One Time Purchase</option></select>";
            } else {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + this.quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'>" + rechargeSelectOptions + "<option value='One Time Purchase'>One Time Purchase</option></select>";
            }

            /* if (rechargeSelected == undefined) {
                 rechargeRadio = '<div class="cart-recahrge-section"><div class="inner"><label class="switch "> <input type="checkbox" data-qty=' + Quantity + '  data-id=' + lineCount + ' class="js__recharge-switch" value="' + value.product_rechargeID + '"  >  <span class="slider"></span></label><span class="text">Subscribe</span><span class="save">Save ' + productRechargeDiscount + '%</span></div><div class="rechargeOptions-outer">' + rechargeOptions + "<span class='update-text' style='display:none'>Update or cancel anytime.</div></span></div>";
              } else {
                 rechargeRadio = '<div class="cart-recahrge-section"><div class="inner"><label class="switch "> <input data-id=' + lineCount + ' class="js__recharge-switch" type="checkbox" value="' + value.product_rechargeID + '" checked >  <span class="slider"></span></label><span class="text">Subscribe</span><span class="save">Save ' + productRechargeDiscount + '%</span></div><div class="rechargeOptions-outer">' + rechargeOptions + "<span class='update-text'>Update or cancel anytime.</span></div></div>";
             }*/
          }
          productTitle = "<h5> <a href='" + url + "' id='product-card-" + this.id + "' tabindex='0'>" + value.product_title.split("with")[0] + " </a></h5>";
        }
      });
      /* get compare price using cartLib object */
      // if (typeof cartLib !== "undefined") {
      //           $.each(cartLib, function(key, value) {
      //               ////console.log(value);
      //               if (value["id"] == itemID) {
      //                   comparePrice = value["comparePrice"];
      //               }
      //           });
      //       }
      /* FORMATTED PRICING */

      if (this.selling_plan_allocation != undefined) {
        comparePrice = this.selling_plan_allocation.compare_at_price;
      }
      var formattedcomparePrice = formatter.format(comparePrice / 100);
      var comparePriceHtml = "";
      if (comparePrice > parseFloat(itemPrice)) {
        comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
      }

      // total compared price for the item with quantity
      var totalListItemComparePrice = formatter.format(comparePrice * this.quantity / 100);
      // item original price
      var formattedItemPrice = formatter.format(itemPrice / 100);
      // line price
      var formattedItemLinePriceTotal = formatter.format(itemLinePriceTotal / 100);
      //final line item price
      var formattedFinalLineItemPrice = formatter.format(finalLineItemPrice / 100);
      //Price after discount
      let showPrice = "";
      let itemPriceAfterDiscountStatus = false;
      let discountedMessage = "";
      let discountedMessageElement = "";
      if (this.discounts != null) {
        discountedMessage = this.discounts;
        if (Object.keys(discountedMessage).length > 0) {
          ////console.log("DISCOUNT EXISTS");
          discountedMessageElement = "<span class='discountedMessage'>";
          $.each(discountedMessage, function (key, value) {
            discountedMessageElement += value.title;
          });
          discountedMessageElement += "</span>";
        }
      }
      var formattedItemPriceAfterDiscount = formatter.format(itemPriceAfterDiscount / 100);
      // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values
      if (this.discounts.length > 0) {
        itemPriceAfterDiscountStatus = true;
      }
      // if it's true; then show the compared price as the main price this.price and main price as discounted price
      if (itemPriceAfterDiscountStatus) {
        //comparePriceHtml
        showPrice = '<span class="price-wrapper js__raw-line-item-price price-value"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
      } else {
        showPrice = '<span class="price-wrapper js__raw-line-item-price price-value"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
      }
      /* check if variantTitle is NULL, then don't show variant */
      var variantTitle = this.variant_title;
      if (variantTitle == null) {
        variantTitle = "";
      }
      var variantData = "";
      $.each(this.options_with_values, function (key, value) {
        ////console.log("key" + key);//console.log("value" + value["name"]);//console.log("value" + value["value"]);
        variantData += "<li><span>" + value["value"].split("with")[0] + "</span></li>";
      });
      /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
          To be applied for all the products with BoxID and Promo Offer
          */
      if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
        //if you want to hide the quantity + - then enable the class below
        // hideElementClass="hide"
        justifyCenter = "justify-center ";
        readonly = "readonly='readonly'";
        disabled = "disabled ";
      }
      /* 
      LINE ITEM FOR THE MINI CART
      */
      // remove anchor
      let removeAnchorElement = '<div class="remove link--primary js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + ">" + removeMiniCartTextOrIcon + "Remove";
      "</div>";

      // Save to wishlist
      // let wishlistAnchorElement =
      // '<button class="btn--addtoWishlist' +
      // removeExtraClass +
      // '" data-cart-line-count="' +
      // lineCount +
      // '" data-variant-id="' +
      // itemID +
      // '"  data-cart-remove-variant="' +
      // this.id + ">" 
      // "Save to Wishlist"
      // "</button>";
      //quantity element
      var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" date-type="minus" onclick="updateCartQuantity(this)"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" data-variant-id="' + itemID + '" onblur="updateCartQuantity(this)" date-type="type" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" date-type="plus" onclick="updateCartQuantity(this)"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>";

      //vendor element
      let vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
      var lineItem;
      lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
      lineItem += '<div class="content"><div class="title-section"> <div class="title-price flex">' + productTitle +
      // removeAnchorElement +
      // wishlistAnchorElement +
      "<span class='price'>" + (itemPriceAfterDiscountStatus ? "<s>" + formattedItemPrice + "</s>" : comparePriceHtml) + formattedItemPriceAfterDiscount + "</span>" + (itemPriceAfterDiscountStatus ? discountedMessageElement : "") + " </div>";
      "";
      if (sellingPlayInformation != "") {
        lineItem += '<p class="uppercase">' + sellingPlayInformation + "</p>";
      }
      if (itemPropertiesElementMiniCart != "") {
        lineItem += '<p class="uppercase">' + itemPropertiesElementMiniCart + "</p>";
      }
      if (variantTitle != "") {
        lineItem += "<ul>" + variantData + "</ul>";
      }
      lineItem +=
      // showPrice +
      '</div><div class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement;
      lineItem += removeAnchorElement + "</div>" + rechargeDropdown + "</div>";
      lineItem += "</li>";
      /* Bind the line item to the list */
      $(".js__ajax-products-bind").append(lineItem);
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }, 1000);

      /*******LINE ITEM FOR THE CART PAGE********/
      if ($(".cart-list")[0]) {
        var cartLineItem = "";
        cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">';
        // show vendor on cart page
        if (showVendorOnCartPage) {
          cartLineItem += vendorElement;
        }
        cartLineItem += productTitle;
        cartLineItem += '<div class="cart-list__variant-properties">';
        if (sellingPlayInformation != "") {
          cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
        }
        if (itemPropertiesElement != "") {
          cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
        }
        if (variantTitle != "") {
          cartLineItem += "<ul>" + variantData + "</ul>";
        }
        cartLineItem += rechargeDropdown + "</div>";
        cartLineItem += '</div>  </div>  <div class="cart-list__items__columns">';
        cartLineItem += showPrice;
        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>';
        cartLineItem += '<a class="remove link--primary" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a></div>  ';

        // ** Remove action is added here too

        cartLineItem += '<div class="cart-list__items__columns total-price " data-head="Total"> <span class="price-wrapper js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>";
        // ** Remove element is added here too
        cartCountEmptyValue += " </div></div>";
        $(".cart-list").append(cartLineItem);
      }
      lineCount++;
    });
  }
}
//CALCULATE TOTAL OF THE CART
function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }
  let total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__minicart-cart-count .count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}
/* REMOVE */
var savedItemPropertyBoxID = "";
$(document).on("click", ".remove", function () {
  var variantID = parseInt($(this).attr("data-variant-id"));
  var clickedLineItemCount = parseInt($(this).attr("data-cart-line-count"));
  var currentLoopItemCount = 1;
  // //console.log(variantID);
  var boxID = "BuilderID";
  var itemsToRemove = [];
  var formData = {
    updates: {}
  };
  $.getJSON("/cart.js", function (cart) {
    var savedItemPropertyBoxID = "";
    // //console.log(cart.items.length);
    // Find the item with the matching variantID and save its BoxID property
    for (var i = 0; i < cart.items.length; i++) {
      if (clickedLineItemCount === currentLoopItemCount) {
        var currentItem = cart.items[i];
        if (currentItem.variant_id === variantID) {
          // //console.log(currentItem);
          // //console.log(currentItem.variant_id);
          // //console.log("variant ID matches");
          // //console.log(currentItem.properties);
          // //console.log(currentItem.properties[boxID]);
          if (currentItem.properties && currentItem.properties[boxID]) {
            savedItemPropertyBoxID = currentItem.properties[boxID];
            // //console.log("Saved Item Property Box ID:", savedItemPropertyBoxID);
            break;
          } else {
            // it doesn't has the BoxID, then delete the particular LineItem
            // //console.log("Current Line Item - With no BoxID")
            itemsToRemove.push(currentItem.variant_id);
          }
        }
      }
      currentLoopItemCount = currentLoopItemCount + 1;
    }
    // Loop through cart items to find items with matching BoxID
    for (var j = 0; j < cart.items.length; j++) {
      var currentItem = cart.items[j];
      if (currentItem.properties && currentItem.properties[boxID] === savedItemPropertyBoxID) {
        itemsToRemove.push(currentItem.variant_id);
        ////console.log("Item Variant ID to Remove:", currentItem.variant_id);
      }
    }
    // //console.log(itemsToRemove);
    // //console.log(itemsToRemove.length);
    // Call the function to remove items from the cart
    removeItemsFromCart(itemsToRemove);
    // Remove items from the cart
  });
});
$(document).on("change", ".js__cart-plan", function () {
  var lineCount = $(this).attr("id").replace('planID', "");
  var lineQuantity = $(this).attr("data-qty");
  var rechargeValue = $(this).val();
  if (rechargeValue == "One Time Purchase") {
    CartJS.updateItem(lineCount, lineQuantity, {
      selling_plan: ""
    }, {
      success: function (data, textStatus, jqXHR) {},
      error: function (jqXHR, textStatus, errorThrown) {}
    });
  } else {
    CartJS.updateItem(lineCount, lineQuantity, {
      selling_plan: parseInt(rechargeValue)
    }, {
      success: function (data, textStatus, jqXHR) {},
      error: function (jqXHR, textStatus, errorThrown) {}
    });
  }
  // rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + this.quantity + " class='custom-dropdown-select js__cart-plan'><option value=" + value.product_rechargeID + " selected>" + value.product_rechargeName + "</option><option value='One Time Purchase'>One Time Purchase</option></select>";
});
// Function to remove items from the cart
function removeItemsFromCart(itemsToRemove) {
  var formData = {
    updates: {}
  };
  // Populate the formData with variant IDs to remove
  for (var k = 0; k < itemsToRemove.length; k++) {
    var variantID = itemsToRemove[k];
    formData.updates[variantID] = 0;
  }
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: formData,
    dataType: "json",
    success: function (cart) {
      getCartData(cart);
    },
    error: function (error) {
      // Handle error if the request fails
      console.error("Error removing items from the cart:", error);
    }
  });
}
function getCartData() {
  $.getJSON("/cart.js", function (cart) {
    cartInfo(cart);
    progressBar();
    setTimeout(function () {
      addons();
    }, 1000);
  });
}
/*
PROGRESS BAR
*/
function progressBar() {
  var totalAmount = 0;
  var shippingGrandTotal = 0;
  if (showProgressBar) {
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => res.json()).then(data => {
      totalAmount = data.total_price / 100;
      var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
      $(".js__free-shipping__icon").removeClass("active");
      shippingGrandTotal = freeShippingAmount;
      var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
      var freeShippingPercentage = 100;
      if (freeShippingRemaningAmount > 0) {
        freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
        $(".js__free-shipping-limit-message").show();
        $(".js__free-shipping-message").hide();
        $(".js__free-shipping").hide();
        $(".js__CartShipping").addClass("hide");
        $(".js__free-shipping-total-section").hide();
        $(".cart-sidebar").removeClass("cart-has-free-shipping");
      } else {
        $(".js__CartShipping").removeClass("hide");
        $(".js__free-shipping-limit-message").hide();
        $(".js__free-shipping-message").show();
        $(".js__free-shipping").show();
        $(".js__free-shipping-total-section").css("display", "flex");
        $(".cart-sidebar").addClass("cart-has-free-shipping");
      }
      $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
      $(".js__grandtotal-shipping").attr("data-percentage", freeShippingPercentage);
      $(".js__grandtotal-shipping").css("width", freeShippingPercentage + "%");
    });
  }
}
var freqProductSlider;
$(document).ready(function ($) {
  //Mini Cart  you may also like product slider

  freqProductSlider = new Swiper('.js__freq-product-slider', {
    slidesPerView: 1,
    spaceBetween: 30,
    freeMode: true,
    watchSlidesProgress: false,
    clickable: true,
    resistance: false,
    shortSwipes: false,
    loop: false,
    threshold: 5,
    // speed: 4000,
    // autoplay: {
    //     delay: 1,
    //     disableOnInteraction: false,
    // },
    pagination: {
      el: ".addons-swiper-pagination",
      clickable: true
    }
  });
  $(".js__addon-add-to-cart").click(function () {
    let quantity = 1;
    let addonSelectedVariantID = $(this).attr("data-attr-variantid");
    let productID = $(this).attr("data-product-id");
    cartAddItemAddon(addonSelectedVariantID, quantity, productID);
  });

  /*
  ADDONS
  NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
  1. Try to get all the addon handles for the items which are in the cart
  2. Create an array for item>addon
  3. Loop through all the cart items and addon
  4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
  */
  function cartAddItemAddon(addonSelectedVariantID, addonQuantity, addonProductID) {
    CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
      success: function (data, textStatus, jqXHR) {
        $(".addons-slide-" + addonProductID).addClass("remove-slide");
        const targetClass = 'remove-slide';
        // Select the <ul> and check if all <li> elements within it have the target class
        const allHaveClass = $('.addons-slide').length === $('.addons-slide.' + targetClass).length;
        freqProductSlider.destroy();
        if (allHaveClass) {
          $(".js__freq-bought-products").addClass("hide");
          //console.log('All <li> elements have the class:', targetClass);
        } else {
          //  freq-product-list-slider

          freqProductSlider = new Swiper('.js__freq-product-slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            freeMode: true,
            watchSlidesProgress: false,
            clickable: true,
            resistance: false,
            shortSwipes: false,
            loop: false,
            threshold: 5,
            // speed: 4000,
            // autoplay: {
            //     delay: 1,
            //     disableOnInteraction: false,
            // },
            pagination: {
              el: ".addons-swiper-pagination",
              clickable: true
            }
          });
        }
        ////console.log("success");
        /* Pending - Remove the selected addon when add to cart is clicked */
      },
      error: function (jqXHR, textStatus, errorThrown) {
        ////console.log("error");
      }
    });
  }

  //Addons are fetched from the schemas; Varies from theme to theme
  setTimeout(function () {
    addons();
  }, 1000);
});
function addons() {
  ////console.log("addons");
  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons .addons-slide").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler");
    // if cartAddon is null,
    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false;
      // going through the string and checking if the current addon handle = the addon
      //handle present in the string
      var cartAddons2 = cartAddons.split(",");
      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).addClass("remove-slide");
          boolCartAddons = true;
        }
      }
      // add the new addon handle to the string
      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    }

    /* Hide the addons from the addon list, if the addon is present in the cart */
    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle");
      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });
    if (boolItemCartAddon == true) {
      $(this).addClass("remove-slide");
    } else {
      $(this).removeClass("remove-slide");
    }
    freqProductSlider.destroy();
    freqProductSlider = new Swiper('.js__freq-product-slider', {
      slidesPerView: 1,
      spaceBetween: 30,
      freeMode: true,
      watchSlidesProgress: false,
      clickable: true,
      resistance: false,
      shortSwipes: false,
      loop: false,
      threshold: 5,
      // speed: 4000,
      // autoplay: {
      //     delay: 1,
      //     disableOnInteraction: false,
      // },
      pagination: {
        el: ".addons-swiper-pagination",
        clickable: true
      }
    });
  });
  /* Hide the complete section if there are no addons */
  var boolAddonExist = false;
  $(".js__freq-product-slider .addons-slide").each(function (index) {
    if (!$(this).hasClass("remove-slide")) {
      boolAddonExist = true;
    }
  });

  ////console.log("boolAddonExist"+boolAddonExist);
  if (boolAddonExist == false) {
    ////console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    ////console.log("else");
    $(".js__freq-bought-products").show();
  }
}
"use strict";

jQuery(function () {
  if ($("body").hasClass("template-product")) {
    $("body").addClass("transparent-header");
  }
  var productSectionSlider = new Swiper(".js__product-section-slider", {
    slidesPerView: 4,
    spaceBetween: 10,
    // centeredSlides: true,
    // resistance: false,
    /* loop duplicates slides in the DOM and breaks in-card Quick Add (wrong tile / jump) */
    loop: false,
    rewind: true,
    resistance: false,
    shortSwipes: true,
    // longSwipes: false,
    // scrollOverflowOptions: null,
    // loopedSlidesLimit: false,
    navigation: {
      nextEl: ".swiper-button-next-product-section",
      prevEl: ".swiper-button-prev-product-section"
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      600: {
        slidesPerView: 1
      },
      601: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      },
      1101: {
        slidesPerView: 4
      }
    }
  });

  /* Hero Banner SLider */
  var heroSlider = new Swiper(".js__hero-banner-slider", {
    slidesPerView: 1,
    resistance: false,
    loop: true,
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    pagination: {
      el: ".swiper-pagination-herobanner",
      clickable: true
    }
  });
  var customProductSlider = new Swiper(".js__product-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
    grabCursor: false,
    loop: true,
    // loopedSlides: 100,
    updateOnWindowResize: true,
    direction: 'horizontal',
    // effect: 'coverflow',
    // freeModeSticky: true,
    freeMode: true,
    freeModeMomentumBounce: false,
    // freeModeMomentumRatio: .1,
    // freeModeMomentumVelocityRatio: .8,
    // freeMode: true,

    // centeredSlides: true,
    threshold: 1,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      481: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      601: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      769: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      981: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: "auto",
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: ".swiper-button-next-product-slider",
      prevEl: ".swiper-button-prev-product-slider "
    }
  });
  var customProductSlider2 = new Swiper(".js__cart-product-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: false,
    // loopedSlides: 100,
    updateOnWindowResize: true,
    direction: 'horizontal',
    // effect: 'coverflow',
    // freeModeSticky: true,
    freeMode: true,
    freeModeMomentumBounce: false,
    // freeModeMomentumRatio: .1,
    // freeModeMomentumVelocityRatio: .8,
    // freeMode: true,

    // centeredSlides: true,
    threshold: 1,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      601: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });

  /* Collection selected*/

  /* PDP
  Tab working */
  $(".tab-link").on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablink = document.getElementsByClassName("tab-link");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";

    /*PDP select*/
    $(".js__pdp-tab-select").val(dataId);
    $(".js__faq-search-section").addClass("hide");
    $(".js__faq-tab").removeClass("hide");
    $(".js__no-data-found").addClass("hide");
    $("#txt-faq-search").val("");
  });
  $(document).on("click", ".pdp-tab-link", function (e) {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("pdp-tab-content");
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper__head-outer").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").children("li").children(".pdp-tab-link").removeClass("active");
    tablink = document.getElementsByClassName("pdp-tab-link");
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    $(this).addClass("active");

    /*PDP select*/
    $(".js__pdp-tab-select").val(dataId);
  });
  /* GLOBAL
  Scroll to particular Div with # value */
  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });

  /* accordion working about content in small screen*/
  $(".js__accordian").children("li").children("h2,h4,h5,h3").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });

  /* Accordion working when we have multiple content*/

  $(".js__accordians").children("li").attr("aria-expanded", false);
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("role", "button");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("tabindex", "0");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").click(function (e) {
    var type = $(this).parent("li").attr("data-attr");
    if ($("." + type).css("display") == "none") {
      $(this).attr("aria-expanded", true);
      $(this).parent("li").parent(".js__accordians").children(".content").hide();
      $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
      $("." + type).slideDown();
      $(this).parent("li").addClass("active");
      $(this).addClass("active");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).parent("li").removeClass("active");
      $("." + type).slideUp();
      $(this).removeClass("active");
    }
  });
  $(".js__accordians").children("li").children("h5,h6,h3,h4").keypress(function (e) {
    if (e.which == 13) {
      var type = $(this).parent("li").attr("data-attr");
      if ($("." + type).css("display") == "none") {
        $(this).attr("aria-expanded", true);
        $(this).parent("li").parent(".js__accordians").children(".content").hide();
        $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
        $("." + type).slideDown();
        $(this).parent("li").addClass("active");
        $(this).addClass("active");
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parent("li").removeClass("active");
        $("." + type).slideUp();
        $(this).removeClass("active");
      }
    }
  });
});

/** Dropdown **/
jQuery(function ($) {
  $(".js__cate-accordian .togglebtn h3").on("click", function () {
    if ($(".js__cate-accordian").children(".rem").css("display") == "none") {
      $(".rem").slideDown(300);
      $(this).parent(".togglebtn").toggleClass("active");
    } else {
      $(".rem").slideUp(300);
      $(".togglebtn").removeClass("active");
    }
  });
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }
    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }
      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".js__active-class li a").each(function () {
    if (this.href === path) {
      $(".js__active-class li a").removeClass("active");
      $(this).addClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */
var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }
    lastScroll = scroll;
  });
});

/** Dropdown **/
jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/
  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();
    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
});
jQuery(function ($) {
  $(".js--open-rates-popup").on("click", function () {
    $(".js__rates-popup").show();
  });
  $(".js__modal-close").on("click", function () {
    $(".modal").hide();
  });
});

/*First tab link and first tab content active */
jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".pdp-tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
  $(".pdp-tab-section .tab-content").first().show();
  $(".pdp-tab-small .tab-content").first().show();
  $(".pdp-tab-content").first().show();
  $(document).on("click", ".js__tab-small", function (e) {
    e.preventDefault();
    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".accordion-link").removeClass("active");
      // $(".tab-content").removeClass("active");

      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active");
      // $(this).parent(".tab-content").addClass("active");
      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-link").removeClass("active");
      // $(this).parent(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
  $(document).on("click", ".js___accordion", function (e) {
    e.preventDefault();
    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active");
      $(".accordion-link").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active");
      // $(this).parent(".tab-content").addClass("active");
      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-link").removeClass("active");
      // $(this).parent(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
});

/*Select Dropdown change wit Tab */
jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val();
    $(".js__faq-search-section").addClass("hide");
    $(".js__faq-tab").removeClass("hide");
    $("#txt-faq-search").val("");
    $(".js__no-data-found").addClass("hide");
    //first hide all tabs again when a new option is selected
    $(".tab-content").hide();
    //then show the tab content of whatever option value was selected
    $("#" + "tab-" + dropdown).show();
    if (dropdown == "all") {
      $(".js__tab-content").each(function () {
        if ($(this).find(".js__accordian").html().trim() == "<li>Sorry Data Is Not Added Yet</li>") {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    }
  });
  $(".js__tab-content").each(function () {
    if ($(this).find(".js__accordian").html().trim() == "") {
      $(this).find(".js__accordian").html('<li>Sorry Data Is Not Added Yet</li>');
    }
  });
});
/*Blog content checking if p tag has image then adding class*/

jQuery(function () {
  $(".article-content p").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      $(this).addClass("full-width");
    }
    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
// jQuery(document).ready(function ($) {
//     // Get the element
//     for (var i = 0; i < 250; i++) {
//       var marqueeFooter = document.querySelector('.js__marquee-right .repeat');
//       // Create a copy of it
//       var cloneFooter = marqueeFooter.cloneNode(true);
//       // Inject it into the DOM
//       marqueeFooter.before(cloneFooter);
//     }
//   });
// Footer dropdown
(function ($) {
  $(function () {
    var navLink = false;
    $(".accordion-toggle-footer-link").on("mousedown", function (e) {
      "use strict";

      e.stopImmediatePropagation();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".accordion-content-footer").slideUp(300);
      } else {
        $(".accordion-toggle-footer-link").removeClass("active");
        $(this).addClass("active");
        $(".accordion-content-footer").slideUp(300);
        $(this).siblings(".accordion-content-footer").slideDown(300);
      }
      navLink = true;
    });
  });
})(jQuery);
/* quick view modal pop up */

jQuery(document).ready(function ($) {
  $(".hero-banner-slider .content").addClass("animate");
});
jQuery(document).ready(function ($) {
  if ($(window).width() > 480) {
    var ImageSlider = new Swiper('.js__image-content-slider', {
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      // resistance: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next-image-content-section",
        prevEl: ".swiper-button-prev-image-content-section"
      }

      // scrollOverflowOptions: null,
      // loopedSlidesLimit: false,
    });
  }
  ;
  var cardSliders = new Swiper('.js_three-column-card-slider1', {
    slidesPerView: "auto",
    spaceBetween: 20,
    freeMode: true,
    watchSlidesProgress: true,
    // clickable: true,
    resistance: false,
    shortSwipes: false,
    loop: true,
    // grabCursor: false,
    // threshold: 1,
    speed: 4000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      376: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      377: {
        slidesPerView: "auto"
      }
    }
  });
  $(".js__image-content-slider .open-order-model").on("click", function () {
    $(".js__order-model").show();
  });
  $(".js__order-popup-close").on("click", function () {
    $(".order-model").hide();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      const popup = document.querySelector('.order-model');
      if (popup && popup.style.display !== 'none') {
        popup.style.display = 'none';
      }
    }
  });
});
jQuery(document).ready(function ($) {
  $(".js__tooltip").on("click", function () {
    $(".js__tooltipmodel").show();
  });
  $(document).on("click", ".js__tooltipmodel", function (e) {
    if (!($(e.target).closest(".tooltip-model-container").length > 0 || $(e.target).closest(".js__tooltip-popup-close").length > 0)) {
      $(this).hide();
    }
  });
  $(document).keydown(function (event) {
    if (event.keyCode == 27) {
      $(".tooltip-model").hide();
    }
  });
  $(".js__tooltip-popup-close").on("click", function () {
    $(".tooltip-model").hide();
  });
  //   $(".js__tooltipmodel").on("click",function(){
  //     $(".tooltip-model").hide();
  //   })
});
jQuery(document).ready(function ($) {
  // if($("div").hasClass("header-transparent")){
  //     $("body").addClass("transparent-header");
  //  }
  jQuery(".order-button").find("a:first").attr("role", "button").attr("aria-haspopup", "true").attr("aria-expanded", "false").on("click", function () {
    var expandedState = jQuery(this).attr('aria-expanded');
    if (expandedState == 'true') {
      jQuery(this).attr("aria-expanded", "false");
      jQuery(".js__main-header").removeClass("active");
      jQuery("body").addClass("transparent-header");
      if (jQuery("body").hasClass("fixed-header")) {
        jQuery("body").removeClass("transparent-header");
      }
      jQuery(this).next().css({
        "opacity": "0",
        "visibility": "hidden",
        "display": "none",
        "pointer-event": "none"
      });
      jQuery(this).parent(".order-button").removeClass("active");
      if (jQuery(".navbar-collapse").hasClass("active")) {
        jQuery(".js__main-header").addClass("active");
        jQuery("body").removeClass("transparent-header");
      }
    } else {
      jQuery(this).attr("aria-expanded", "true");
      jQuery(".js__main-header").addClass("active");
      jQuery("body").removeClass("transparent-header");
      jQuery(this).next().css({
        "opacity": "1",
        "visibility": "visible",
        "display": "block",
        "pointer-event": "all"
      });
      jQuery(this).parent(".order-button").addClass("active");
      if (jQuery(".js__search").hasClass("active")) {
        jQuery(".js__search").removeClass("active");
        jQuery(".js__header-search-section").removeClass("active");
      }
    }
    return false;
  });
  $(document).click(function (e) {
    var container = jQuery(".order-button");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      jQuery(".order-button").children("a").attr("aria-expanded", "false");
      jQuery(".js__main-header").removeClass("active");
      jQuery("body").addClass("transparent-header");
      if (jQuery("body").hasClass("fixed-header")) {
        jQuery("body").removeClass("transparent-header");
      }
      jQuery(".order-button").children("a").next().css({
        "opacity": "0",
        "visibility": "hidden",
        "display": "none",
        "pointer-event": "none"
      });
      jQuery(".order-button").removeClass("active");
      if (jQuery("header").hasClass("fixed") === true) {
        jQuery("body").removeClass("transparent-header");
      } else {
        jQuery("body").removeClass("transparent-header");
        jQuery(".js__main-header").removeClass("active");
      }
    }
  });
  $(document).on("click", ".js__card-add-to-cart", function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.data("cartjs-adding")) return;
    var selectedVariantID = $btn.attr("data-variant-id");
    if (!selectedVariantID) return;
    var originalLabel = $btn.data("cartjs-label-original");
    if (originalLabel == null) {
      originalLabel = $.trim($btn.text());
      $btn.data("cartjs-label-original", originalLabel);
    }
    $btn.data("cartjs-adding", true);
    $btn.attr("aria-busy", "true");
    $btn.text("Adding...");
    var quantity = 1;
    var items = [];
    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    function restoreLabel() {
      $btn.data("cartjs-adding", false);
      $btn.removeAttr("aria-busy");
      $btn.text($btn.data("cartjs-label-original"));
    }
    CartJS.addItems(items, {
      success: function (response, textStatus, jqXHR) {
        restoreLabel();
        $(".modal-quick-view").hide();
        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        restoreLabel();
        showCartErrorMessage();
      }
    });
  });
});
"use strict";

var showCartMessage = true;
jQuery(function () {
  //Nav - Open and Close Mini cart

  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
    });
  }
  /* Cart - Free Shipping Progress bar Visiblity */
  try {
    if (getglobalLib("Free_Shipping_progressbar") == "yes" && $(".js__free-shipping-limit").html().trim() != "" && showProgressBar == true) {
      $(".js__progressbar_visiblity").removeClass("hide");
    }
  } catch {}

  /* Remove mini cart from the cart page */
  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */
  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });
  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }
  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    if (productQuantity > 1) {
      productQuantity--;
    }
    $(".js__quantity-selector").val(productQuantity);
  }
});

/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/
function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  if (showCartMessage == true) {
    $("#cart-message").addClass("message-success");
    $("#cart-message").removeClass("message-error");
    $("#cart-message").html("Successfully added to cart!");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}
function showCartErrorMessage() {
  if (showCartMessage == true) {
    $("#cart-message").removeClass("message-success");
    $("#cart-message").addClass("message-error");
    $("#cart-message").html("Sorry! Seems like the product is out of stock");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}
function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.json()).then(data => {
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active");
  });
}

/* EVENT: When the cart request is completed everytime the below function is run */
$(document).on("cart.requestComplete", function (event, cart) {
  reloadAjaxCartItemUsingCartAjaxObject(cart);
  //Progress Bar of shipping in cart and mini cart; Varies from theme to theme
  progressBar();
  //Show and hide empty cart depending upon the cart items
  setTimeout(function () {
    // calculateSubTotalWithDiscount();
    addons();
  }, 1000);
});

// $(document).on("cart.requestStarted", function (event, cart) {//console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */
  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }
  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: true
    });
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  var announcementSlider = new Swiper(".js__announcement-slider", {
    slidesPerView: 1,
    resistance: false,
    shortSwipes: true,
    loop: false,
    autoHeight: true
  });

  /* Announcement 
  Close on Click  */
  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });
  if ($("body").hasClass("template-cart")) {
    $("body").removeClass("transparent-header");
  }
  if ($("body").hasClass("template-search")) {
    $("body").removeClass("transparent-header");
  }

  /* MEGAMENU
    active link while submenu open */
  if ($(window).width() > 980) {
    $('.has-sub-nav').hover(function (event) {
      event.stopPropagation(); // Stop event propagation
      // Adding a extra link to give anchor hover effect
      $(this).children(".site-nav__link").addClass("hover-submenu");
      // Give Visibility and opacity to the Sub nav menu
      $(this).children(".sub-nav").css("visibility", "visible");
      $(this).children(".sub-nav").css("opacity", "1");
      $(this).children(".sub-nav").css("z-index", "1");
      $(this).children(".sub-nav").addClass("active");
      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");
      // Remove transparent header from index page when sub menu open
      $(".template-index").addClass("remove-transparent-header");
      if ($(".js__search ").hasClass("active") == true) {
        $(".js__header-search-section").removeClass("active");
        $(".js__search ").removeClass("active");
        $("body .boost-pfs-search-suggestion").css("display", "none");
        $("body #boost-sd__search-widget-init-wrapper-1").css("display", "none");
      }
    }, function (event) {
      event.stopPropagation(); // Stop event propagation
      // Remove  extra link to remove anchor hover effect
      $(this).children(".site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav").children(".site-nav__link").removeClass("hover-submenu");
      // Remove Visibility and opacity from the Sub nav menu
      $(".has-sub-nav").children(".sub-nav").css("visibility", "hidden");
      $(".has-sub-nav").children(".sub-nav").css("opacity", "0");
      $(".has-sub-nav").children(".sub-nav").removeClass("active");
      // $(this).children(".sub-nav").css("z-index", "-10");
      if ($(".js__header-search-section").hasClass("active") === true) {
        $(".main-header").addClass("active");
      } else {
        $(".main-header").removeClass("active");
      }
      // $(".main-header").removeClass("active");
      if ($("body").hasClass("fixed-header")) {
        $("body").removeClass("transparent-header");
      } else {
        $("body").addClass("transparent-header");
        if ($(".main-header").hasClass("active")) {
          $("body").removeClass("transparent-header");
        } else {
          if ($("div").hasClass("hero-banner") || $("body").hasClass("template-product") || $("div").hasClass("error-page") || $("div").hasClass("inner-hero-section")) {
            $("body").addClass("transparent-header");
          }
          //   else{
          //     if ($("div").hasClass("white-bg") === true) {
          //         $("body").removeClass("transparent-header");
          //         $("body").removeClass("template-index");
          //     }
          //     $("body").removeClass("transparent-header");
          //   }
        }
      }
      $("body").removeClass("remove-transparent-header");
    });
    $('.has-big-nav').hover(function (event) {
      event.stopPropagation(); // Stop event propagation
      // Adding a extra link to give anchor hover effect
      $(this).children(".site-nav__link").addClass("hover-submenu");
      // Give Visibility and opacity to the Big nav menu
      $(this).children(".big-nav").css("visibility", "visible");
      $(this).children(".big-nav").css("opacity", "1");
      $(this).children(".big-nav").addClass("active");
      // Remove transparent header from index page when big nav menu open
      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");
      if ($(".js__search").hasClass("active") == true) {
        $(".js__header-search-section").removeClass("active");
        $(".js__search").removeClass("active");
        $("body .boost-pfs-search-suggestion").css("display", "none");
        $("body #boost-sd__search-widget-init-wrapper-1").css("display", "none");
      }
    }, function (event) {
      event.stopPropagation(); // Stop event propagation
      // Remove  extra link to remove anchor hover effect
      $(this).children(".site-nav__link").removeClass("hover-submenu");
      // Remove Visibility and opacity from the Big nav menu
      $(".has-big-nav .big-nav").css("visibility", "hidden");
      $(".has-big-nav .big-nav").css("opacity", "0");
      $(".has-big-nav").children(".big-nav").removeClass("active");
      if ($(".js__header-search-section").hasClass("active") === true) {
        $(".main-header").addClass("active");
      } else {
        $(".main-header").removeClass("active");
      }

      // Add transparent header from index page when sub menu open
      if ($("body").hasClass("fixed-header")) {
        $("body").removeClass("transparent-header");
      } else {
        $("body").addClass("transparent-header");
        if ($(".main-header").hasClass("active")) {
          $("body").removeClass("transparent-header");
        }
      }
    });
  }

  //  Sub Menu in MObile
  /* SubMenu
     Accordion JS */
  (function ($) {
    $(function () {
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        if (document.documentElement.classList.contains("env-macos") && $(e.target).closest("a.shopify-dns-link-icon").length) {
          return;
        }

        e.stopImmediatePropagation();
        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 981) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
          }
        }
        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 980) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        }
      });
    });
  })(jQuery);

  // sEARCH BAR
  if ($(window).width() > 980) {
    $(document).click(function (e) {
      var container = $(".search-li");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".js__header-search-section").removeClass("active");
        $(".js__search").removeClass("active");
        $("body").addClass("transparent-header");
        if ($("body").hasClass("template-search") === true) {
          $("body").removeClass("transparent-header");
        }
        $("body .boost-pfs-search-suggestion").css("display", "none");
        $("body #boost-sd__search-widget-init-wrapper-1").css("display", "none");
        //         if($(".js__main-header").hasClass("active") === true){
        //   $("body").removeClass("transparent-header");
        //   }
        if ($("header").hasClass("fixed") === true) {
          $("body").removeClass("transparent-header");
        } else {
          //    $("body").removeClass("transparent-header");
          //    $(".js__main-header").removeClass("active");
        }
      }
    });
  }
  $(".js__search").on("click", function (e) {
    e.preventDefault();
    $(".js__header-search-section").toggleClass("active");
    $("#navbarNavDropdown").removeClass("active");
    // $(".announcement-bar").removeClass("active");
    $("#hamburger").removeClass("active");
    $(".search").focus();
    $(".boost-pfs-search-box").focus();
    $(this).toggleClass("active");
    $(".js__main-header").addClass("active");
    $("body").removeClass("transparent-header");
    if ($("body").hasClass("template-search")) {
      $("body").removeClass("transparent-header");
      // $(".main-header").removeClass("active");
    }
    if ($("body").hasClass("fixed-header")) {
      $("body").removeClass("transparent-header");
    }
    if ($(this).hasClass("active")) {
      $("body").removeClass("transparent-header");
    } else {
      $("body").addClass("transparent-header");
      $(".js__main-header").removeClass("active");
    }
    if ($(".order-button").hasClass("active")) {
      $(".order-button").children("a").next().css({
        "opacity": "0",
        "visibility": "hidden",
        "display": "none",
        "pointer-event": "none"
      });
      $(".order-button").removeClass("active");
      $(".order-button").children("a").attr("aria-expanded", "false");
      $(".js__main-header").removeClass("active");
    }
    // if ($("div").hasClass("inner-hero-section")===false || $("div").hasClass(".hero-banner-slider")===false ){
    //     $("body").removeClass("transparent-header");
    // }
    // if ($("div").hasClass("inner-hero-section")  || $("div").hasClass("error-page") || $("div").hasClass("hero-banner-slider")) {
    //     if($(".js__main-header").hasClass("active") === true){
    //         $("body").removeClass("transparent-header");
    //     }
    //     else{
    //         if ($("body").hasClass("fixed-header")) {
    //             $("body").removeClass("transparent-header");
    //         }
    //         else{
    //             $("body").addClass("transparent-header"); 
    //         }

    //     }

    //     // $("body").addClass("transparent-header");
    //     // $("body").addClass("template-index");
    // }
  });
});

/** Fix Header on Scroll **/
$(window).scroll(function () {
  var sticky = $("header"),
    scroll = $(window).scrollTop();
  if (scroll >= 30) {
    sticky.addClass("fixed");
    $("body").addClass("fixed-header");
    $("body").removeClass("transparent-header");
  } else {
    sticky.removeClass("fixed");
    $("body").removeClass("fixed-header");
    $("body").addClass("transparent-header");
    $(".main-header").removeClass("active");
    if ($("body").hasClass("template-cart")) {
      $("body").removeClass("transparent-header");
    }
    if ($("body").hasClass("template-search")) {
      $("body").removeClass("transparent-header");
      // $(".main-header").removeClass("active");
    }
    if ($(".js__search ").hasClass("active") == true) {
      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");
    }
    if ($("#navbarNavDropdown").hasClass("active")) {
      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");
    }
    if ($(".order-button").hasClass("active")) {
      $("body").removeClass("transparent-header");
      jQuery(".js__main-header").addClass("active");
    }
    // else {
    //     if($("div").hasClass("hero-banner") || $("div").hasClass("error-page")  || $("div").hasClass("inner-hero-section") || $("div").hasClass("header-transparent") ){
    //         $("body").addClass("transparent-header");
    //       }

    //      else{$("body").removeClass("transparent-header");}

    // }

    // if($(".js__main-header").hasClass("active") === true){
    //     $("body").removeClass("transparent-header");
    // }
    // else{
    //     if($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("div").hasClass("inner-hero-section") || $("div").hasClass("header-transparent") ){
    //         $("body").addClass("transparent-header");
    //       }
    //       else{
    //         $("body").removeClass("transparent-header");
    //       }
    //     //   $("body").removeClass("transparent-header");
    // }
  }
});

/** Mobile Navigation Open Close **/
// (function($) {
//     $(function() {
//         var navLink = false;
//         $("#hamburger .hamburger")
//             .mousedown(function(e) {
//                 $(this).addClass("active");
//                 $(this).parent("#hamburger").addClass("active");
//                 $(this).parent("#hamburger").children(".close").removeClass("active");

//                 $("#navbarNavDropdown").addClass("active");
//                 $(".js__mobile-menu-open-hide").addClass("active");
//                 $(".js__mobile-announcement-text").addClass("active");
//                 $(".main-header").addClass("active");
//                 // $(".announcement-bar").toggleClass("active");
//                 $("body").removeClass("transparent-header");

//                 if ($("body").hasClass("fixed-header")) {
//                     $("body").removeClass("transparent-header");
//                 }
//                 else{
//                     if($(this).parent("#hamburger").children(".close").hasClass("active")){
//                         $("body").addClass("transparent-header");
//                     }

//                 }

//                 if ($("#navbarNavDropdown").hasClass("active")) {
//                     $(".js__logo").addClass("active");
//                     $("body").removeClass("transparent-header");
//                     $(".main-header").addClass("active");
//                     if ($(window).width() < 980) {
//                         $("html").css("overflow", "hidden");
//                         $("html").addClass("scroll-stop");
//                     } else {
//                         $("html").removeClass("scroll-stop");
//                         $("html").css("overflow-y", "scroll");
//                     }

//                 } else {
//                     $(".js__logo").removeClass("active");
//                     // $(this).parent("#hamburger").removeClass("active");
//                     $(".main-header").removeClass("active");
//                     $("body").addClass("transparent-header");
//                     if ($("body").hasClass("fixed-header")) {
//                         $("body").removeClass("transparent-header");
//                     } 
//                     $("html").css("overflow-y", "scroll");
//                     $("body .boost-pfs-search-suggestion-group").css("display","none");

//                 }
//                 navLink = true;
//             })
//             .focus(function(e) {
//                 "use strict";
//                 if (navLink) {} else {
//                     $(this).addClass("active");
//                     $(this).parent("#hamburger").addClass("active");
//                     $(this).parent("#hamburger").children(".close").removeClass("active");
//                     $("#navbarNavDropdown").addClass("active");
//                     $(".js__mobile-menu-open-hide").addClass("active");
//                     $(".js__mobile-announcement-text").addClass("active");
//                     $("body").removeClass("transparent-header");
//                     if ($("#navbarNavDropdown").hasClass("active")) {
//                         $(".js__logo").addClass("active");
//                         $("body").removeClass("transparent-header");
//                         $(".main-header").addClass("active");
//                         if ($(window).width() < 980) {
//                             $("html").css("overflow", "hidden");
//                             $("html").addClass("scroll-stop");
//                         } else {
//                             $("html").removeClass("scroll-stop");
//                             $("html").css("overflow-y", "scroll");
//                         }
//                     } else {
//                         $(".js__logo").removeClass("active");
//                         // $(this).parent("#hamburger").removeClass("active");
//                         $(".main-header").removeClass("active");
//                         $("body").addClass("transparent-header");
//                         if ($("body").hasClass("fixed-header")) {
//                             $("body").removeClass("transparent-header");
//                         } 
//                         $("html").css("overflow-y", "scroll");
//                         $("body .boost-pfs-search-suggestion-group").css("display","none");
//                     }   
//                 }

//             });
//     });

// })(jQuery);
// (function($) {
//     $(function() {
//         var navLink = false;
//         $("#hamburger .close")
//             .mousedown(function(e) {
//                 $(this).addClass("active");
//                 $(this).parent("#hamburger").removeClass("active");
//                 $(this).parent("#hamburger").children(".hamburger").removeClass("active");
//                 $("#navbarNavDropdown").removeClass("active");
//                 $(".js__mobile-menu-open-hide").removeClass("active");
//                 $(".js__mobile-announcement-text").removeClass("active");
//                 $(".main-header").removeClass("active");
//                 // $(".announcement-bar").toggleClass("active");
//                 $("body").addClass("transparent-header");

//                 if ($("body").hasClass("fixed-header")) {
//                     $("body").removeClass("transparent-header");
//                 }
//                 // else{
//                 //     $("body").addClass("transparent-header");
//                 // }

//                 if ($("#navbarNavDropdown").hasClass("active")) {
//                     $(".js__logo").addClass("active");
//                     $("body").removeClass("transparent-header");
//                     $(".main-header").addClass("active");
//                     if ($(window).width() < 980) {
//                         $("html").css("overflow", "hidden");
//                         $("html").addClass("scroll-stop");
//                     } else {
//                         $("html").removeClass("scroll-stop");
//                         $("html").css("overflow-y", "scroll");
//                     }
//                 } else {
//                     $(".js__logo").removeClass("active");
//                     // $(this).parent("#hamburger").removeClass("active");
//                     $(".main-header").removeClass("active");
//                     $("body").addClass("transparent-header");
//                     if ($("body").hasClass("fixed-header")) {
//                         $("body").removeClass("transparent-header");
//                     } 
//                     $("html").css("overflow-y", "scroll");
//                     $("body .boost-pfs-search-suggestion-group").css("display","none");
//                 }   
//                 navLink = true;
//             })
//             .focus(function(e) {
//                 "use strict";
//                 if (navLink) {} else {
//                     $(this).addClass("active");
//                     $(this).parent("#hamburger").removeClass("active");
//                     $(this).parent("#hamburger").children(".hamburger").removeClass("active");
//                     $("#navbarNavDropdown").removeClass("active");
//                     $(".js__mobile-menu-open-hide").removeClass("active");
//                     $(".js__mobile-announcement-text").removeClass("active");
//                     $("body").addClass("transparent-header");
//                     if ($("#navbarNavDropdown").hasClass("active")) {
//                         $(".js__logo").addClass("active");
//                         $("body").removeClass("transparent-header");
//                         $(".main-header").addClass("active");
//                         if ($(window).width() < 980) {
//                             $("html").css("overflow", "hidden");
//                             $("html").addClass("scroll-stop");
//                         } else {
//                             $("html").removeClass("scroll-stop");
//                             $("html").css("overflow-y", "scroll");
//                         }
//                     } else {
//                         $(".js__logo").removeClass("active");
//                         // $(this).parent("#hamburger").removeClass("active");
//                         $(".main-header").removeClass("active");
//                         $("body").addClass("transparent-header");
//                         if ($("body").hasClass("fixed-header")) {
//                             $("body").removeClass("transparent-header");
//                         } 
//                         $("html").css("overflow-y", "scroll");
//                         $("body .boost-pfs-search-suggestion-group").css("display","none");
//                     }   

//                 }

//             });
//     });

// })(jQuery);
/** CART SIDEBAR
 * Close on Outside Click
 * **/
$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");
  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
/* OPEN BIG NAV SECTION ON DESKTOP */
(function ($) {
  $(function () {
    var navLink = false;
    $(".js__big-nav-link").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__big-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__big-nav").toggleClass("active");
      }
    });
  });
})(jQuery);
/* OPEN SUB NAV SECTION ON MOBILE */
(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-link").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__sub-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__sub-nav").toggleClass("active");
      }
    });
  });
})(jQuery);

// Close MOBILE SUB NAV ON CLICK BACK 
(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-close").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__sub-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__sub-nav").toggleClass("active");
      }
    });
    setTimeout(function () {
      if ($("body").hasClass("template-product")) {
        $("body").addClass("transparent-header");
      }
    }, 500);
  });
})(jQuery);
jQuery(document).ready(function ($) {
  // if($("div").hasClass("header-transparent")){
  //     $("body").addClass("transparent-header");
  //  }
  jQuery("#hamburger").attr("role", "button").attr("aria-haspopup", "true").attr("aria-expanded", "false").on("click", function () {
    var expandedState = jQuery(this).attr('aria-expanded');
    if (expandedState == 'true') {
      jQuery(this).attr("aria-expanded", "false");
      jQuery("#navbarNavDropdown").removeClass("active");
      jQuery("body").addClass("transparent-header");
      jQuery(".main-header").removeClass("active");
      if (jQuery("body").hasClass("fixed-header")) {
        jQuery("body").removeClass("transparent-header");
      }
      jQuery(this).removeClass("active");
      if (jQuery(".navbar-collapse").hasClass("active")) {
        jQuery(".js__main-header").addClass("active");
        jQuery("body").removeClass("transparent-header");
      }
      if ($(window).width() < 980) {
        $("html").css("overflow", "scroll");
        $("html").removeClass("scroll-stop");
      }
    } else {
      jQuery(this).attr("aria-expanded", "true");
      jQuery("#navbarNavDropdown").addClass("active");
      jQuery("body").removeClass("transparent-header");
      jQuery(".main-header").addClass("active");
      jQuery(this).addClass("active");
      if (jQuery(".js__search").hasClass("active")) {
        jQuery(".js__search").removeClass("active");
        jQuery(".js__header-search-section").removeClass("active");
      }
      if ($(window).width() < 980) {
        $("html").css("overflow", "hidden");
        $("html").addClass("scroll-stop");
      } else {
        $("html").removeClass("scroll-stop");
        $("html").css("overflow-y", "scroll");
      }
    }
    return false;
  });
});
"use strict";

var pdpThumbnail;
var pdpSlider;
$(document).ready(function ($) {
  var producrSlider = new Swiper('.js__pdp-recommendation-slider', {
    slidesPerView: 3,
    autoHeight: true,
    resistance: false,
    shortSwipes: true,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next-product-recommed',
      prevEl: '.swiper-button-prev-product-recommed'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      601: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      }
    }
  });

  /*Slider working Start*/
  if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      slidesPerView: 3,
      resistance: false,
      shortSwipes: false,
      clickable: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      draggable: true,
      breakpoints: {
        980: {
          slidesPerView: "auto",
          direction: "horizontal"
        },
        981: {
          slidesPerView: 6,
          direction: "vertical"
        }
      }
    });
  } else {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      resistance: false,
      shortSwipes: true,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      mousewheel: true,
      direction: "horizontal",
      spaceBetween: 12
    });
  }
  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    grabCursor: false,
    mousewheel: false,
    clickable: false,
    resistance: false,
    shortSwipes: true,
    spaceBetween: 12,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-pdp",
      prevEl: ".swiper-button-prev-pdp"
    },
    thumbs: {
      swiper: pdpThumbnail
    }
  });
  /*PDP tab section drop down change*/
  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });

  /* var pdpSlideCount = 0;
   $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function(e) {
           var ariaLabel = $(".js__pdp-slider").find(".swiper-slide-active").attr("aria-label").split("/");
           //console.log(ariaLabel[0]);
           //console.log(ariaLabel[1]);
           pdpSlideCount++;
           if (pdpSlideCount == 2) {
               if (ariaLabel[0].trim() == ariaLabel[1].trim()) {
                   pdpSlideCount = 0
                   pdpSlider.slideTo(0);
               }
           }
        })*/
  /* Manual click of thumbnail of slider*/
  $(document).on("click", ".pdp-thumbnail li", function (e) {
    var slideno = $(this).index();
    $(".pdp-thumbnail li").removeClass("active");
    $(this).addClass("active");
    $(".pdp-slider").slick("slickGoTo", slideno);
    setTimeout(function () {
      $(".pdp-thumbnail").slick("slickGoTo", slideno);
    }, 500);
    /* var slideno = $(this).index();
             $(".pdp-thumbnail li").removeClass("active");
             $(this).addClass("active");
             //console.log("slideno"+slideno);
       
             $(".pdp-slider").slick("slickGoTo", slideno);*/
  });
  /*Write review click*/
  $(".js__write-review-btn").click(function () {
    $(".yotpo-new-review-btn").click();
  });

  /*View details*/
  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".tab-head li:first-child").children(".tab-link").addClass("active");
    $(".tab-content").removeClass("active");
    $(".tab-content:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first-child").show();
    $(".js__pdp-tab-select").val($(".tab-head li:first-child").children(".tab-link").attr("data-attr"));
    setTimeout(function () {
      var target = $(".tab-content:first-child");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });

  /*Review star click*/
  $(document).on("click", ".js__review-section", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $("#tab-link-reviews").addClass("active");
    $(".tab-content").removeClass("active");
    $("#reviews").addClass("active");
    $(".tab-content").hide();
    $("#reviews").show();
    $(".js__pdp-tab-select").val("Reviews");
    setTimeout(function () {
      var target = $("#reviews");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });

  /*Ninja price update */
  var targetNodes = $(".product__form");
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  var bundleObersrver = new MutationObserver(mutationHandler);
  var obsConfig = {
    childList: true,
    characterData: true,
    attributes: true,
    subtree: true
  }; //--- Add a target node to the observer. Can only add one node at a time.

  targetNodes.each(function () {
    bundleObersrver.observe(this, obsConfig);
  });
  function mutationHandler(mutationRecords) {
    //loop through all the mutations that just occured
    mutationRecords.forEach(function (mutation) {
      if (mutation.type == "childList") {
        //loop though the added nodes
        mutation.addedNodes.forEach(function (added_node) {
          // //console.log($(".rc-container-wrapper").html())

          if ($(".rc-container-wrapper").html() != undefined) {
            ////console.log("click recharge active");
            $(".label-recharge-info").remove();
            if ($(".js__subscribeText").html() != "") {
              $(".rc-option__subsave").append("<span class='label-recharge-info'>" + $(".js__subscribeText").html() + "</span>");
            }
            if ($(".js__onetimeText").html() != "") {
              $(".rc-option__onetime").append("<span class='label-recharge-info'>" + $(".js__onetimeText").html() + "</span>");
            }
            setTimeout(function () {
              $(".rc-option--active").click();
            }, 500);
            bundleObersrver.disconnect();
          }
          setTimeout(function () {
            //console.log("sub price" + $(".rc_widget__price--subsave").html());
            //console.log("onetime price" + $(".rc_widget__price--onetime").html());
            $(".rc-option__subsave").children(".rc_widget__option__label").children("s").remove();
            $(".rc-option__subsave").children(".rc_widget__option__label").append(" <s>" + $(".rc_widget__price--onetime").html() + "</s>");
            //console.log("sub price 2" + $(".rc_widget__price--subsave").html());
            $(".rc-option--active").click();
          }, 500);
        });
      }
    });
  }

  /* change frequency dropdown checking if   value not null then change button text */

  $(document).on("change", ".rc_widget__option__plans__dropdown", function (e) {
    $(".rc-option--active").click();
  });
  $(document).on("click", ".rc_widget__option", function (e) {
    ////console.log("onetime ");

    var price = $(this).find(".rc-option__price").html();
    $(".pdp-add-to-cart-price").html(price);
    $(".js__pdp-variant-select li.active").click();
  });

  /*Slider working End*/
  /* Call page load functions */
  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */
  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color);
        //$(this).children("div.color").css("background-color", colorValue);
        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }
        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/
function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/
    return variantColorValue;
  } catch {}
}
/* Color swatch click*/
$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");
    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }
  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val());

  // on page load check the color position, and set 2nd and 3rd options values
  checkColorPosition();
  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */
    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }

  /*Quantity Plus Minus*/
  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();
    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }
    $(".js-quantity-selector").val(productQuantity);
  });

  // On DD change, fire the form DD element and also run the soldoutColorSwatches function
  $(".js__pdp-variant-select").change(function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue);
    $(this).parent(".select").children(".label").children("span").html(optionValue);
    // button  - Sold out and add to cart
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    /*Checking if this is filter type then image filter code will work*/
    var OptionType = $(this).attr("data-type");
    var FilterType = $("#variantFilterType").val();
    if (OptionType == FilterType) {
      imageFilter(optionValue);
    }
    var selectedVariant = $("#product-select :selected").text().replace("- sold out!", "");
    $(".js__product-variant-selected").html(selectedVariant);
    $(".rc-option--active").click();

    //color swatch - sold out working
    SoldOutUnavailableOnColorSwatches(colorSelected);
  });
  $(document).on("click", ".js__pdp-variant-select li", function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).attr("data-value");
    var optionType = $(this).parent("ul").attr("data-type");
    $(this).parent("ul").children("li").removeClass("active");
    $(this).addClass("active");
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    $("#product-select").change();

    /*Checking if this is filter type then image filter code will work*/
    try {
      var FilterType = $("#variantFilterType").val();
      if (optionType == FilterType) {
        imageFilter(optionValue);
      }
    } catch {}
    // button  - Sold out and add to cart

    try {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    } catch {}
    //color swatch - sold out working
  });
  $(".js__pdp-variant-select li.active").click();
  $(".js__color-swatches").click(function () {
    // remove active class - from all the li's
    $('.js__color-swatches').removeClass('active');
    // add class on the one which is clicked
    $(this).addClass('active');
    var optionindex = $(this).data('option');
    var thevalue = $(this).data('value');

    //show the selected value
    $('.variant-option.option-' + optionindex + ' .label span').text(thevalue);

    // trigger change
    $('#product-select-option-' + optionindex).val(thevalue).trigger('change');

    /*Checking if this is filter type then image filter code will work*/
    var OptionType = $(this).parent("ul").attr("data-type");
    var FilterType = $("#variantFilterType").val();
    if (OptionType == FilterType) {
      imageFilter(thevalue);
    }
  });

  /*Run this function when image change on variant click*/
  function imageFilter(selectedValue) {
    /*Slick slider filter on swatch click*/
    var thumbColorSelected = selectedValue.replace(" ", "-");
    thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
    thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/---/g, "-");

    // $(".pdp-slider").slick("slickUnfilter");
    //   $(".js__pdp-thumbnail-slider").slick("slickUnfilter");
    $(".pdp-slider").find(".all").addClass(thumbColorSelected.toLowerCase());
    $(".js__pdp-thumbnail-slider").find(".all").addClass(thumbColorSelected.toLowerCase());
    //   $(".pdp-slider").slick("slickFilter", "." + thumbColorSelected.toLowerCase());
    //  $(".js__pdp-thumbnail-slider").slick( "slickFilter","." + thumbColorSelected.toLowerCase());
    $(".js__pdp-thumbnail-slider .swiper-slide").removeClass("active");
    //$(".js__pdp-thumbnail-slider").slick("refresh");

    $(".pdp-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".js__pdp-thumbnail-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".pdp-slider").find(".slide").children(".image-section").removeAttr("data-fancybox");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".js__pdp-thumbnail-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).children(".image-section").attr("data-fancybox", "product");
    pdpThumbnail.destroy();
    pdpSlider.destroy();
    if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        slidesPerView: 3,
        resistance: false,
        shortSwipes: false,
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        draggable: true,
        breakpoints: {
          980: {
            slidesPerView: "auto",
            direction: "horizontal"
          },
          981: {
            slidesPerView: 6,
            direction: "vertical"
          }
        }
      });
    } else {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        resistance: false,
        shortSwipes: true,
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        mousewheel: true,
        spaceBetween: 10
      });
    }
    pdpSlider = new Swiper(".js__pdp-slider", {
      slidesPerView: 1,
      grabCursor: false,
      mousewheel: false,
      clickable: false,
      resistance: false,
      shortSwipes: true,
      loop: true,
      spaceBetween: 12,
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      },
      thumbs: {
        swiper: pdpThumbnail
      }
    });

    /*Selected first variant image in slider which have no all class*/
    var boolVariantFirstImage = false;
    $(".js__pdp-thumbnail-slider  li").each(function () {
      if (!$(this).hasClass("all")) {
        if (boolVariantFirstImage == false) {
          $(this).click();
          $(this).addClass("active");
          boolVariantFirstImage = true;
        }
      }
    });
    /*When we dont have any variant image*/

    if (boolVariantFirstImage == false) {
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").click();
    }
    colorSelected = selectedValue;
  }
  // main sold out and unavailable working
  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition();

    // Remove out of stock and unavailable from color swatches
    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
    Loop Through each input radio for the color
    */

    // we are using color swatch working for other options when they are radio buttons
    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */

      /*
      PENDING - Merge - ProdLib Each Function
      */

      $.each(prodLib, function (key, value) {
        let itemQuantity = value.quantity;
        let itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";
        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }
        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }
        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }
        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/
        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }
        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });
      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");
        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;
          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }
      colorCount++;
    });
  }
  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $(".js__pdp-variant-select1").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }
      if (colorPosition == "2") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }
      if (colorPosition == "3") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
        }
      }
    } else {
      secondOptionVariantValue = $(".js__pdp-variant-select0").val();
      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
      }
    }
    try {
      colorSelected = colorSelected.toLowerCase();
    } catch {}
  }
  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }
  $(window).scroll(function () {
    var sticky = $(".product__media-outer"),
      scroll = $(window).scrollTop();
    var pos = sticky.height();
    if (scroll >= 768 & scroll <= pos - 690) {
      sticky.addClass("fixed");
      // $(".main-content").addClass("active");
    } else {
      sticky.removeClass("fixed");
      // $(".main-content").removeClass("active");
    }
  });

  // show para on click read More button

  $(".js__read-more_btn").click(function () {
    $(".js__read-less-content").addClass("hide");
    $(".js__read-more-content").removeClass("hide");
  });
  $(".js__read-less_btn").click(function () {
    $(".js__read-less-content").removeClass("hide");
    $(".js__read-more-content").addClass("hide");
  });
});
"use strict";

jQuery(function ($) {
  var state = {
    product: null,
    selections: {},
    currentVariant: null
  };
  var ui = null;
  var previousFocus = null;

  /** Shopify share-preview host: product JSON often has every variant `available: false`. */
  function isQuickAddSharePreviewHost() {
    try {
      return /\.shopifypreview\.com$/i.test(location.hostname || "");
    } catch (e) {
      return false;
    }
  }

  /** Allow Quick Add UI + submit on preview; checkout/cart still enforce real inventory. */
  function variantIsPurchasableInQuickAdd(v) {
    if (!v) return false;
    if (isQuickAddSharePreviewHost()) return true;
    return !!v.available;
  }
  function getPanelReq($panel) {
    if (!$panel || !$panel.length) return 0;
    var v = $panel.attr("data-quick-add-req");
    if (v == null || v === "") return 0;
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }
  function setPanelReq($panel, n) {
    if (!$panel || !$panel.length) return;
    $panel.attr("data-quick-add-req", String(n));
  }

  /** Bump counter; returns new value (use as request id for the next fetch). */
  function incrementPanelReq($panel) {
    var next = getPanelReq($panel) + 1;
    setPanelReq($panel, next);
    return next;
  }
  function clearPanelLoading($panel) {
    if (!$panel || !$panel.length) return;
    var $ld = $panel.find(".quick-add-modal__loading");
    $ld.prop("hidden", true).attr("hidden", "hidden").hide();
    $panel.find(".quick-add-modal__inner").removeClass("is-loading-content").css("opacity", "");
  }
  function showPanelLoading($panel) {
    if (!$panel || !$panel.length) return;
    var $ld = $panel.find(".quick-add-modal__loading");
    $ld.removeAttr("hidden").prop("hidden", false).show();
  }
  function productJsonUrl(handle) {
    var root = "";
    if (typeof window.Shopify !== "undefined" && window.Shopify.routes && typeof window.Shopify.routes.root === "string") {
      root = window.Shopify.routes.root.replace(/\/$/, "");
    }
    return root + "/products/" + encodeURIComponent(handle) + ".js";
  }
  function normalizeProductOptions(product) {
    if (!product.options || !product.options.length) return product;
    if (typeof product.options[0] === "string") {
      var opts = [];
      for (var i = 0; i < product.options.length; i++) {
        var pos = i + 1;
        var vals = {};
        product.variants.forEach(function (v) {
          var val = v["option" + pos];
          if (val != null && val !== "") vals[val] = true;
        });
        opts.push({
          name: product.options[i],
          position: pos,
          values: Object.keys(vals)
        });
      }
      product.options = opts;
    }
    return product;
  }
  function moneyFormatTemplate() {
    return window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "${{amount}}";
  }
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    var template = moneyFormatTemplate();
    var amount = (Number(cents) / 100).toFixed(2);
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      try {
        return Shopify.formatMoney(cents, template);
      } catch (e) {}
    }
    return template.replace(/\{\{\s*amount\s*\}\}/gi, amount);
  }
  function bindUi($panel) {
    ui = {
      $panel: $panel,
      $loading: $panel.find(".quick-add-modal__loading"),
      $inner: $panel.find(".quick-add-modal__inner"),
      $title: $panel.find(".quick-add-modal__title"),
      $price: $panel.find(".quick-add-modal__price"),
      $optionsRoot: $panel.find(".quick-add-modal__options"),
      $error: $panel.find(".quick-add-modal__error"),
      $submit: $panel.find(".js__quick-add-submit"),
      $qtyInput: $panel.find(".js__quick-add-qty-input")
    };
  }
  function getQuickAddQty() {
    if (!ui || !ui.$qtyInput || !ui.$qtyInput.length) return 1;
    var q = parseInt(ui.$qtyInput.val(), 10);
    return isNaN(q) || q < 1 ? 1 : q > 999 ? 999 : q;
  }
  function showError(msg) {
    if (!ui) return;
    if (msg) {
      ui.$error.text(msg).prop("hidden", false);
    } else {
      ui.$error.text("").prop("hidden", true);
    }
  }
  function closeActivePanel(skipFocusRestore) {
    if (!ui || !ui.$panel || !ui.$panel.length) {
      ui = null;
      $(document).off("keydown.quickAdd");
      return;
    }
    incrementPanelReq(ui.$panel);
    clearPanelLoading(ui.$panel);
    ui.$panel.removeClass("is-open is-loading").attr("aria-hidden", "true");
    showError("");
    ui.$submit.removeClass("is-loading");
    ui = null;
    state.product = null;
    state.selections = {};
    state.currentVariant = null;
    $(document).off("keydown.quickAdd");
    $(".product-card .image-section").removeClass("quick-add-panel-open");
    if (!skipFocusRestore && previousFocus && previousFocus.focus) {
      try {
        previousFocus.focus({
          preventScroll: true
        });
      } catch (e) {
        previousFocus.focus();
      }
      previousFocus = null;
    }
  }
  function openPanel($panel) {
    var focusBefore = document.activeElement;
    closeActivePanel(true);
    previousFocus = focusBefore;
    bindUi($panel);
    $panel.addClass("is-open").attr("aria-hidden", "false");
    $panel.closest(".image-section").addClass("quick-add-panel-open");
    $(document).on("keydown.quickAdd", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeActivePanel();
      }
    });
  }
  function ensureQuickAddPanel($scope) {
    return $scope.find(".js__quick-add-panel").first();
  }

  /** Scope to .image-section inside the card (button may sit below image, not inside .image-section). */
  function quickAddScopeFromButton($btn) {
    var $slide = $btn.closest(".swiper-slide");
    if ($slide.length) {
      return $slide.find(".image-section").first();
    }
    var $wrap = $btn.closest(".product-wrapper");
    if ($wrap.length) {
      return $wrap.find(".image-section").first();
    }
    return $btn.closest(".image-section");
  }
  function applyProductDataToUi(product) {
    if (!ui) return;
    normalizeProductOptions(product);
    state.product = product;
    if (ui.$title.length) ui.$title.text(product.title);
    if (ui.$qtyInput.length) ui.$qtyInput.val(1);
    renderOptions(product);
    refreshOptionAvailability();
    try {
      ui.$submit[0].focus({
        preventScroll: true
      });
    } catch (err) {
      try {
        ui.$submit.focus();
      } catch (e2) {}
    }
  }
  function optionPosition(opt, index) {
    return typeof opt.position === "number" ? opt.position : index + 1;
  }
  function findVariantForSelections(product, selections) {
    return product.variants.find(function (v) {
      for (var i = 0; i < product.options.length; i++) {
        var pos = optionPosition(product.options[i], i);
        if (v["option" + pos] !== selections[pos]) return false;
      }
      return true;
    });
  }
  function firstAvailableVariant(product) {
    var found = product.variants.find(function (v) {
      return v.available;
    });
    if (found) return found;
    if (isQuickAddSharePreviewHost() && product.variants.length) {
      return product.variants[0];
    }
    return undefined;
  }
  function validOptionValuesForPosition(product, selections, positionToFill) {
    var pos = positionToFill;
    return product.variants.filter(function (v) {
      if (!isQuickAddSharePreviewHost() && !v.available) return false;
      for (var i = 0; i < product.options.length; i++) {
        var p = optionPosition(product.options[i], i);
        if (p === pos) continue;
        if (v["option" + p] !== selections[p]) return false;
      }
      return true;
    }).map(function (v) {
      return v["option" + pos];
    }).filter(function (xx, i, arr) {
      return arr.indexOf(xx) === i;
    });
  }
  function setVariantUi(variant) {
    if (!ui) return;
    state.currentVariant = variant;
    if (!variant) {
      if (ui.$price.length) ui.$price.empty();
      ui.$submit.prop("disabled", true);
      showError("Unavailable");
      return;
    }
    if (ui.$price.length) {
      var html = '<span class="quick-add-modal__price-current">' + formatMoney(variant.price) + "</span>";
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<s class="quick-add-modal__price-compare">' + formatMoney(variant.compare_at_price) + "</s>" + html;
      }
      ui.$price.html(html);
    }
    ui.$submit.prop("disabled", !variantIsPurchasableInQuickAdd(variant)).removeClass("is-loading");
    if (!variantIsPurchasableInQuickAdd(variant)) {
      showError(window.theme && theme.strings && theme.strings.soldOut || "This variant is sold out");
    } else {
      showError("");
    }
  }
  function readSelectionsFromDom() {
    var sel = {};
    if (!ui) return sel;
    ui.$optionsRoot.find(".js__quick-add-option").each(function () {
      var pos = parseInt($(this).attr("data-option-position"), 10);
      var $active = $(this).find(".js__quick-add-swatch.is-selected");
      if ($active.length) sel[pos] = String($active.data("value"));
    });
    return sel;
  }
  function syncDomToSelection(pos, val) {
    if (!ui) return;
    var $control = ui.$optionsRoot.find('.js__quick-add-option[data-option-position="' + pos + '"]').first();
    if (!$control.length) return;
    $control.find(".js__quick-add-swatch").removeClass("is-selected");
    $control.find(".js__quick-add-swatch").filter(function () {
      return String($(this).data("value")) === String(val);
    }).addClass("is-selected");
  }

  /** Like validOptionValuesForPosition but skips undecided positions (null/undefined in selections). */
  function validOptionValuesProgressive(product, selections, positionToFill) {
    var pos = positionToFill;
    return product.variants.filter(function (v) {
      if (!isQuickAddSharePreviewHost() && !v.available) return false;
      for (var i = 0; i < product.options.length; i++) {
        var p = optionPosition(product.options[i], i);
        if (p === pos) continue;
        if (selections[p] == null) continue;
        if (v["option" + p] !== selections[p]) return false;
      }
      return true;
    }).map(function (v) {
      return v["option" + pos];
    }).filter(function (xx, i, arr) {
      return arr.indexOf(xx) === i;
    });
  }
  function renderOptions(product) {
    if (!ui) return;
    ui.$optionsRoot.empty();
    var fv = firstAvailableVariant(product);
    var base = {};
    if (fv) {
      for (var i = 0; i < product.options.length; i++) {
        var pos = optionPosition(product.options[i], i);
        base[pos] = fv["option" + pos];
      }
    }

    /* Build selections progressively so the first option shows all values,
       the second filters based on the first, etc. */
    var progressive = {};
    product.options.forEach(function (opt, index) {
      var pos = optionPosition(opt, index);
      /* Show ALL values for each option; refreshOptionAvailability will disable unavailable ones */
      var values = opt.values ? opt.values.slice() : [];
      if (!values.length) values = validOptionValuesProgressive(product, progressive, pos);
      var $group = $('<div class="quick-add-modal__option-group"/>');
      var nameStr = opt.name || "Option";
      $group.append('<div class="quick-add-modal__option-label">' + String(nameStr).replace(/:\s*$/, "") + ":</div>");
      var currentVal = base[pos];
      if (values.indexOf(currentVal) === -1 && values[0] !== undefined) currentVal = values[0];
      if (currentVal !== undefined) progressive[pos] = currentVal;
      var $row = $('<div class="quick-add-modal__swatches js__quick-add-option"/>').attr("data-option-position", pos);
      values.forEach(function (val) {
        var $btn = $('<button type="button" class="quick-add-modal__swatch js__quick-add-swatch"/>').attr("data-value", val).text(val);
        if (val === currentVal) $btn.addClass("is-selected");
        $row.append($btn);
      });
      $group.append($('<div class="quick-add-modal__option-control"/>').append($row));
      if (index > 0) $group.addClass("quick-add-modal__option-group--divider");
      ui.$optionsRoot.append($group);
    });
    state.selections = readSelectionsFromDom();
    setVariantUi(findVariantForSelections(product, state.selections));
  }
  function refreshOptionAvailability() {
    /* Match Shopify PDP behaviour: all option values stay enabled.
       If the combination has no variant or the variant is OOS,
       setVariantUi shows "Sold out" / disables Add to Cart. */
  }
  function fixSelections() {
    /* No auto-fixing — let the user pick any combination freely.
       If no matching variant exists, setVariantUi(null) disables
       Add to Cart and shows "Unavailable". This matches the live
       site PDP where all option combos are selectable. */
    state.selections = readSelectionsFromDom();
  }
  function onSelectionChange() {
    fixSelections();
    state.selections = readSelectionsFromDom();
    var variant = findVariantForSelections(state.product, state.selections);
    setVariantUi(variant);
    refreshOptionAvailability();
  }
  function loadProduct(handle) {
    if (!ui || !ui.$panel || !ui.$panel.length) {
      return typeof Promise !== "undefined" ? Promise.resolve() : $.Deferred().resolve().promise();
    }
    var $p = ui.$panel;
    var reqId = incrementPanelReq($p);
    showPanelLoading($p);
    showError("");
    var url = productJsonUrl(handle);
    var timeoutMs = 25000;
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timeoutId = setTimeout(function () {
      if (controller) controller.abort();
    }, timeoutMs);
    var fetchOpts = {
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/javascript, */*"
      }
    };
    if (controller) fetchOpts.signal = controller.signal;
    var doneUi = function () {
      clearTimeout(timeoutId);
      if (getPanelReq($p) === reqId) {
        clearPanelLoading($p);
      }
    };
    if (typeof fetch !== "function") {
      return $.getJSON(url).done(function (product) {
        if (getPanelReq($p) !== reqId) return;
        if (!ui || !ui.$panel || ui.$panel[0] !== $p[0]) return;
        try {
          applyProductDataToUi(product);
        } catch (err) {
          showError("Could not display product options.");
          state.product = null;
        }
      }).fail(function () {
        if (getPanelReq($p) !== reqId) return;
        if (ui && ui.$panel && ui.$panel[0] === $p[0]) {
          showError("Could not load product. Please try again.");
          state.product = null;
        }
      }).always(doneUi);
    }
    return fetch(url, fetchOpts).then(function (res) {
      if (getPanelReq($p) !== reqId) return null;
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    }).then(function (product) {
      if (getPanelReq($p) !== reqId || !product) return;
      if (!ui || !ui.$panel || ui.$panel[0] !== $p[0]) return;
      try {
        applyProductDataToUi(product);
      } catch (err) {
        showError("Could not display product options.");
        state.product = null;
      }
    }).catch(function () {
      if (getPanelReq($p) !== reqId) return;
      if (ui && ui.$panel && ui.$panel[0] === $p[0]) {
        showError("Could not load product. Please try again.");
        state.product = null;
      }
    }).then(doneUi, doneUi);
  }
  function addToCartAjax(variantId, quantity, $submitBtn) {
    if (!variantId || !window.CartJS) {
      if (typeof showCartErrorMessage === "function") showCartErrorMessage();else if (ui) showError("Cart is not available.");
      return;
    }
    var $sub = $submitBtn && $submitBtn.length ? $submitBtn : $();
    if ($sub.length) $sub.addClass("is-loading").prop("disabled", true);
    var items = [{
      id: variantId,
      quantity: quantity
    }];
    CartJS.addItems(items, {
      success: function () {
        closeActivePanel();
        if (typeof showCartSuccessMessage === "function") {
          showCartSuccessMessage();
        } else if (typeof getglobalLib === "function" && getglobalLib("Mini_Cart") === "yes") {
          setTimeout(function () {
            if (typeof openMiniCart === "function") openMiniCart();
          }, 400);
        } else {
          window.location = "/cart";
        }
      },
      error: function () {
        if (typeof showCartErrorMessage === "function") showCartErrorMessage();else if (ui) showError("Could not add to cart. Please try again.");
        if ($sub.length) $sub.removeClass("is-loading");
        if (ui && state.currentVariant && variantIsPurchasableInQuickAdd(state.currentVariant)) {
          ui.$submit.prop("disabled", false);
        }
      }
    });
  }
  function handleQuickAddTrigger(e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this);
    if ($btn.prop("disabled")) return;
    var handle = $btn.attr("data-product-handle");
    var onlyDefault = $btn.attr("data-only-default") === "true";
    var onlyDefaultFalse = $btn.attr("data-only-default") === "false";
    var variantId = $btn.attr("data-variant-id");
    if (onlyDefault && variantId) {
      addToCartAjax(parseInt(variantId, 10), 1, null);
      return;
    }
    if (!handle) return;
    var $scope = quickAddScopeFromButton($btn);
    if (!$scope.length) return;
    var $panel = ensureQuickAddPanel($scope);
    if (!$panel.length) return;
    if (onlyDefaultFalse && variantId) {
      openPanel($panel);
      loadProduct(handle);
      return;
    }
  }
  $(document).on("click", ".js__quick-add", handleQuickAddTrigger);

  /* iOS two-tap fix: fire quick-add on touchend so the panel opens immediately
     without waiting for the browser's hover→click sequence */
  $(document).on("touchend", ".js__quick-add", function (e) {
    var $btn = $(this);
    if ($btn.prop("disabled")) return;
    /* Prevent the subsequent click from firing a second time */
    e.preventDefault();
    handleQuickAddTrigger.call(this, e);
  });
  $(document).on("click", ".js__quick-add-close", function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeActivePanel();
  });
  $(document).on("click", ".js__quick-add-panel", function (e) {
    e.stopPropagation();
  });
  $(document).on("click", function (e) {
    if (!ui || !ui.$panel) return;
    var $t = $(e.target);
    if ($t.closest(".js__quick-add-panel").length) return;
    if ($t.closest(".js__quick-add").length) return;
    closeActivePanel();
  });
  $(document).on("click", ".js__quick-add-swatch", function (e) {
    e.stopPropagation();
    var $sw = $(this);
    if ($sw.prop("disabled")) return;
    $sw.siblings().removeClass("is-selected");
    $sw.addClass("is-selected");
    onSelectionChange();
  });
  $(document).on("click", ".js__quick-add-panel .js__quick-add-qty-minus", function (e) {
    e.stopPropagation();
    if (!ui || !ui.$qtyInput.length) return;
    var v = parseInt(ui.$qtyInput.val(), 10) || 1;
    if (v > 1) ui.$qtyInput.val(v - 1);
  });
  $(document).on("click", ".js__quick-add-panel .js__quick-add-qty-plus", function (e) {
    e.stopPropagation();
    if (!ui || !ui.$qtyInput.length) return;
    var v = parseInt(ui.$qtyInput.val(), 10) || 1;
    if (v < 999) ui.$qtyInput.val(v + 1);
  });
  $(document).on("click", ".js__quick-add-panel .js__quick-add-submit", function (e) {
    e.stopPropagation();
    if (!state.currentVariant || !variantIsPurchasableInQuickAdd(state.currentVariant) || !ui) return;
    var qty = getQuickAddQty();
    addToCartAjax(state.currentVariant.id, qty, ui.$submit);
  });

  /** When Quick View (Boost modal, role=dialog, or .modal-quick-view) closes, reset quick-add + hover */
  var externalModalWasOpen = false;
  var suppressQuickAddFallbackTimer = null;
  var overlaySyncTimer = null;
  function isElementVisiblyOpen(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute("aria-hidden") === "true") return false;
    if (el.hasAttribute("hidden")) return false;
    var st = window.getComputedStyle(el);
    if (st.display === "none" || st.visibility === "hidden" || Number(st.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /** Visible dialog / modal shell (Boost may omit role; class-based fallbacks included). */
  function isLikelyQuickViewShell(el) {
    if (!isElementVisiblyOpen(el)) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 64 || r.height < 64) return false;
    return true;
  }
  function anyQuickViewOverlayOpen() {
    var i;
    var selectors = [".modal-quick-view", ".boost-sd__modal", "[role=\"dialog\"]", "[role=\"alertdialog\"]", "dialog[open]", "[aria-modal=\"true\"]"];
    for (var s = 0; s < selectors.length; s++) {
      var nodes = document.querySelectorAll(selectors[s]);
      for (i = 0; i < nodes.length; i++) {
        /* Skip our own quick-add panels — they are not external Quick View overlays */
        if (nodes[i].classList && nodes[i].classList.contains("js__quick-add-panel")) continue;
        if (isLikelyQuickViewShell(nodes[i])) return true;
      }
    }
    return false;
  }
  function blurFocusInsideProductCards() {
    var ae = document.activeElement;
    if (ae && ae.closest && ae.closest(".product-card") && typeof ae.blur === "function") {
      ae.blur();
    }
  }
  function teardownSuppressQuickAddListeners() {
    $(document).off("mouseleave.suppressQuickAddOverlay", ".product-card .product-wrapper");
    $(document).off("touchstart.suppressQuickAddOverlay");
    $(window).off("scroll.suppressQuickAddOverlay");
    if (suppressQuickAddFallbackTimer) {
      clearTimeout(suppressQuickAddFallbackTimer);
      suppressQuickAddFallbackTimer = null;
    }
  }
  function resetQuickAddAfterQuickViewClose() {
    teardownSuppressQuickAddListeners();
    closeActivePanel();
    blurFocusInsideProductCards();
    $("body").addClass("js__suppress-product-card-quick-add");
    var cleared = false;
    function clearSuppress() {
      if (cleared) return;
      cleared = true;
      teardownSuppressQuickAddListeners();
      $("body").removeClass("js__suppress-product-card-quick-add");
    }
    suppressQuickAddFallbackTimer = setTimeout(clearSuppress, 15000);
    setTimeout(function () {
      /* Pointer must leave the card (not just move inside it) — avoids hover sticking after modal close */
      $(document).on("mouseleave.suppressQuickAddOverlay", ".product-card .product-wrapper", clearSuppress);
      $(document).on("touchstart.suppressQuickAddOverlay", function (e) {
        if (!$(e.target).closest(".product-card").length) clearSuppress();
      });
      $(window).on("scroll.suppressQuickAddOverlay", clearSuppress);
    }, 0);
  }
  function syncQuickViewOverlayState() {
    var open = anyQuickViewOverlayOpen();
    if (externalModalWasOpen && !open) {
      resetQuickAddAfterQuickViewClose();
    }
    externalModalWasOpen = open;
  }
  function scheduleOverlaySync() {
    if (overlaySyncTimer) clearTimeout(overlaySyncTimer);
    overlaySyncTimer = setTimeout(function () {
      overlaySyncTimer = null;
      syncQuickViewOverlayState();
    }, 0);
    setTimeout(syncQuickViewOverlayState, 150);
    setTimeout(syncQuickViewOverlayState, 450);
  }
  externalModalWasOpen = anyQuickViewOverlayOpen();
  if (window.MutationObserver) {
    var moOverlay = new MutationObserver(function () {
      syncQuickViewOverlayState();
    });
    moOverlay.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-hidden", "hidden", "style", "class"]
    });
  }
  $(document).on("click", scheduleOverlaySync);
  $(document).on("keyup", function (e) {
    if (e.key === "Escape") scheduleOverlaySync();
  });
});